export { mapWorkspaceToOrganization } from './mapWorkspaceToOrganization'
